import _slicedToArray from "/home/technative/projects/signify/17thjuly/signify-app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { useState, useLayoutEffect } from 'react';
import { getContentWidth } from '../helpers/style.js';
import { useResizeNotifier } from './useResizeNotifier.js';
export function useContentWidth(element) {
  var _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    width = _useState2[0],
    setWidth = _useState2[1];
  function syncWidth() {
    var newWidth = element ? getContentWidth(element) : undefined;
    if (width !== newWidth) {
      setWidth(newWidth);
    }
  }
  useResizeNotifier(element, syncWidth);
  useLayoutEffect(syncWidth);
  return width;
}